// @flow

import type {Node, StatelessFunctionalComponent} from 'react';

import styled from '@emotion/styled';

export const Container: StatelessFunctionalComponent<{
  children: Node,
}> = styled.div`
  padding: 40px 16px;
  text-align: center;
  max-width: 564px;
  margin: 0 auto;

  img {
    width: 240px;
    margin: 0 auto;
  }
`;
